import './CardScroller.css';

import React from 'react';

import classname from '@search/classname/src';

const cn = classname.bind(null, 'CardScroller');

export function CardScroller({
    controls,
    children,
    isLeftMask,
    isRightMask,
    isBottomMargin,
    containerRef,
    autoWidth,
    onContainerScroll,
    isLeftMargin
}: {
    autoWidth?: boolean;
    onContainerScroll?(e: React.UIEvent<HTMLDivElement> & { target?: HTMLDivElement }): void;
    containerRef?: React.RefObject<HTMLDivElement>;
    isLeftMask?: boolean;
    isRightMask?: boolean;
    isBottomMargin?: boolean;
    isLeftMargin?: boolean;
    controls?: React.ReactNode;
    children: React.ReactNode;
}) {
    return (
        <div
            className={cn(null, { left: isLeftMask, right: isRightMask, bottom: isBottomMargin, leftMargin: isLeftMargin })}
        >
            <div
                ref={containerRef}
                onScroll={onContainerScroll}
                className={cn('content', { autoWidth })}
            >
                {children}
            </div>
            {controls}
        </div>
    );
}
